import size from  "lodash.size";

import { getExeStatus, setExeStatus } from "../utils/exeStatus.js";

const CartHelper = function (Cart, CrossSell, $q, Voucher, ShippingMethodService, Discount, TicketFormatService) {
    const exeStatus = getExeStatus();
    var service = {};

    service.factory = function ($scope) {

        //  Send Voucher Form
        $scope.redeemVoucher = function () {
            $scope.redeemVoucherError = "";
            exeStatus.voucher = 2;
            if ((!document.getElementById('voucher-input').value) || document.getElementById('voucher-input').value == "") {
                if (typeof $scope.translations[ 'custom' ] === "undefined" || typeof $scope.translations[ 'custom' ][ 'no_voucher_code_error' ] === "undefined") {
                    $scope.translations[ 'custom' ] = translations;
                }
                $scope.redeemVoucherError = $scope.translations[ "custom" ][ 'no_voucher_code_error' ];
                return 0;
            }
            $scope.ajaxCall('cart', 'redeemvoucher', 'POST', { voucher: $scope.voucherCode }, function (response) {
                exeStatus.voucher = '';

                if (response.status) {
                    response.product.productid = response.product.id;
                    $scope.cartItems[ 'product' + '-' + response.product.id ] = response.product;
                    $scope.redeemVoucherError = "";
                    $scope.showVoucherForm = false;
                    $scope.usingVoucher = true;
                    $scope.scrollCartToBottom();

                    $scope.updateCartSum();
                } else {
                    $scope.redeemVoucherError = response.error;
                }

                document.getElementById('voucher-input').value = '';
            }, function (error) {
                exeStatus.voucher = 0;
                $scope.redeemVoucherError = error;


            });
        };

        $scope.checkOnlyVoucherInCart = function () {
            if (size($scope.cartItems) == 1 && $scope.buyingVoucher) {
                $scope.onlyVoucherInCart = true;
            }
        };

        $scope.allowShippingMethodInCart = function (doLoginValidation) {
            return (!doLoginValidation || ($scope.formStatus && ($scope.formStatus.userLoggedIn || $scope.formStatus.guestLoggedIn)) || amazonLoggedIn) &&
                ShippingMethodService.methods.length &&
                ((!this.onlyGiftWrapperInBasket && !this.ticketsInCart) || (this.ticketsInCart && TicketFormatService.formats.length));
        };

        $scope.checkBuyingVoucher = function () {
            $scope.buyingVoucher = false;
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) continue;
                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "product" && cartItem.id == 999999999) {
                    $scope.buyingVoucher = true;
                }
            }
            $scope.checkOnlyVoucherInCart();
        };

        $scope.checkUsingVoucher = function () {
            Voucher.resetItem();
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) {
                    continue;
                }
                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "voucher") {
                    Voucher.setItem(cartItem);
                    Cart.voucher = Voucher;
                    Cart.paymentVoucher = Voucher;
                }
            }
        };

        $scope.removeVoucher = function () {
            Cart.paymentVoucher = null;
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) {
                    continue;
                }
                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "voucher") {
                    $scope.removeFromCart(cartItem, key);
                    Voucher.resetItem();
                }
            }
        };

        $scope.removeVoucherFromCart = function () {
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) {
                    continue;
                }

                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "voucher") {
                    delete $scope.cartItems[ key ];
                    Voucher.resetItem();
                    $scope.updateCartSum();
                    $scope.countProducts--;
                    break;
                }
            }
        };


        $scope.addInsuranceToCart = function () {
            $scope.cartItems[ 'insurance' ] = {
                "type": "insurance",
                "name": $scope.insuranceOffer.name,
                "description": $scope.insuranceOffer.description,
                "amount": 1,
                "price": $scope.insuranceOffer.price,
                "image": "img/purchase/other/icon_insurance.png",
            };
            $scope.insuranceInCart = true;
            $scope.scrollCartToBottom();
        };

        //  Add Insurance
        $scope.addInsurance = function () {
            if (!exeStatus.insurance) {
                exeStatus.insurance = 2;
                $scope.ajaxCall('cart', 'addinsurance', 'POST', { insurance: $scope.insuranceOffer }, function (response) {
                    if (response.status) {
                        exeStatus.insurance = null;
                        $scope.addInsuranceToCart();
                        if (response.discount) {
                            Discount.setDiscount(response.discount, $scope);
                        }
                        $scope.updateCartSum();
                    } else {
                        exeStatus.insurance = 0;

                    }
                }, function (error) {
                    $scope.displayError(error);

                    exeStatus.insurance = 0;

                });
            }
        };


        $scope.toggleInsurance = function () {

            if ($scope.insuranceInCart) {
                $scope.removeFromCart($scope.cartItems[ 'insurance' ], 'insurance');
            }
            else {
                $scope.addInsurance();
            }
        };
        $scope.removeInsurance = function () {
            if ($scope.insuranceInCart) {
                $scope.removeFromCart($scope.cartItems[ 'insurance' ], 'insurance');
            }
        };

        $scope.checkIfOnlyGiftWrapperIsInCart = function () {
            for (var item in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(item)) {
                    continue;
                }

                var currentCartItem = $scope.cartItems[ item ];
                if (typeof currentCartItem.isGiftWrapper !== "undefined" && currentCartItem.isGiftWrapper) {
                    $scope.hasGiftWrapper = true;
                } else {
                    $scope.onlyGiftWrapperInBasket = false;
                }
            }

            if ($scope.hasGiftWrapper && $scope.onlyGiftWrapperInBasket) {
                return true;
            }
            return false;
        };

        $scope.getDiscountPrice = function (item) {
            if ((item.discountprice > 0 || item.discountprice === 0) && item.discount > 0) {
                return true;
            }
            return false;
        };

        $scope.checkIfTicketsInCart = function () {
            $scope.ticketsInCart = false;
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) continue;

                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "event" || cartItem.type === 'bundle' && !angular.equals({}, cartItem.seats)) {
                    $scope.ticketsInCart = true;
                    return true;
                }
            }
            return false;
        };

        /**
         * @returns {boolean}
         */
        $scope.checkIfProductsInCart = function () {
            var isInCart = false;

            for (let key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) {
                    continue;
                }

                var cartItem = $scope.cartItems[ key ];

                if (cartItem.type == 'product') {
                    isInCart = true;
                    break;
                }
            }

            return isInCart;
        };

        $scope.clearCartIfNoTickets = function () {
            var onlyGiftWrapperInCart = $scope.checkIfOnlyGiftWrapperIsInCart();
            if (onlyGiftWrapperInCart) {
                for (var key in $scope.cartItems) {
                    if (!$scope.cartItems.hasOwnProperty(key)) {
                        continue;
                    }
                    var cartItem = $scope.cartItems[ key ];
                    if (cartItem.productid !== 999999999) {
                        $scope.removeFromCart(cartItem, key);
                    }
                }
            }
        };

        $scope.clearUnpermittedProducts = function () {
            if (typeof CrossSell.productCategories === 'undefined') {
                for (var key in $scope.cartItems) {
                    if (!$scope.cartItems.hasOwnProperty(key)) {
                        continue;
                    }
                    var cartItem = $scope.cartItems[ key ];
                    if (cartItem.type === "product" && cartItem.productid !== 999999999) {
                        $scope.removeFromCart(cartItem, key);
                    }
                }
            }
        };

        /**
         * @param {{}} item
         */
        function removeProductFromLocalStorage(item) {
            var cart = JSON.parse(localStorage.getItem('cart'));
            if (Array.isArray(cart)) {
                cart = cart.filter(function (cartItem) {
                    return cartItem.type !== 'product' || parseInt(cartItem.productId) !== item.productid;
                });
            }
            if (!Array.isArray(cart) || cart.length === 0) {
                localStorage.removeItem('cartTimeout');
                cart = [];
            }
            localStorage.setItem('cart', JSON.stringify(cart));
        }

        /**
         * @param {Cart.Product|Cart.Bundle} item
         * @param {String} key
         * @return {Promise}
         */
        $scope.removeFromCart = function (item, key) {
            var deferred = $q.defer();
            if (!(key in exeStatus.items)) {
                //execStatus 0-error, 1-success, 2-in progress
                exeStatus.items[ key ] = null;
            }

            var action, post;

            switch (item.type) {
                case 'insurance':
                    action = 'removeinsurance';
                    post = { insurance: item };
                    break;

                case 'voucher':
                case 'product':
                    action = 'removeproduct';
                    post = { product: item };
                    break;
                case 'bundle':
                    action = 'removebundle';
                    post = { bundle: item };
                    break;
                case 'discounttype':
                    action = 'removediscount';
                    post = { discount: item };
                    break;

                default:
                    if (typeof gtmHelper === 'object') {
                        gtmHelper.pushRemoveFromCart(item.id);
                    }

                    action = 'removeseat';
                    post = { seatid: item.id };
            }

            if (!exeStatus.items[ key ]) {
                exeStatus.items[ key ] = 2;

                $scope.ajaxCall('cart', action, 'POST', post, function (response) {
                    $scope.confirmDelete = null;

                    if (response.status) {
                        if (item.eventid && item.type != 'bundle') {
                            if ($scope.cartItemsSummarized[ item.eventid ].amount === 1) {
                                delete $scope.cartItemsSummarized[ item.eventid ];
                            } else {
                                $scope.cartItemsSummarized[ item.eventid ].amount = $scope.cartItemsSummarized[ item.eventid ].amount - 1;
                                $scope.cartItemsSummarized[ item.eventid ].price = $scope.cartItemsSummarized[ item.eventid ].price - item.price;
                            }

                            if ($scope.ticketRequiresPersonalizationList[ item.eventid ] && $scope.ticketRequiresPersonalizationList[ item.eventid ][ item.id ]) {
                                delete $scope.ticketRequiresPersonalizationList[ item.eventid ][ item.id ];
                                delete $scope.personalizedTicketForm[ item.id ];

                            }
                        } else if (item.type === 'bundle') {
                            for (var i in item.seats) {
                                if (!item.seats.hasOwnProperty(i)) {
                                    continue;
                                }

                                var bundleSeat = item.seats[ i ];
                                if ($scope.ticketRequiresPersonalizationList[ bundleSeat.eventid ] && $scope.ticketRequiresPersonalizationList[ bundleSeat.eventid ][ bundleSeat.id ]) {
                                    delete $scope.ticketRequiresPersonalizationList[ bundleSeat.eventid ][ bundleSeat.id ];
                                    delete $scope.personalizedTicketForm[ bundleSeat.id ];
                                }
                                if (Object.keys($scope.ticketRequiresPersonalizationList).length > 0 && Object.keys($scope.ticketRequiresPersonalizationList[ bundleSeat.eventid ]).length === 0) {
                                    delete $scope.ticketRequiresPersonalizationList[ bundleSeat.eventid ];
                                }
                            }
                        }
                        if (Object.keys($scope.personalizedTicketForm).length === 0) {
                            $scope.showTicketPersonalizeForm = false;
                        }


                        exeStatus.items[ key ] = null;
                        delete $scope.cartItems[ key ];
                        $scope.checkAndRemoveEventAGB(item);

                        if (response.checkout_options) {
                            $scope.setCheckoutOptions(angular.fromJson(response.checkout_options), angular.fromJson(response.checkout_translations));
                        }

                        switch (item.type) {
                            case 'insurance':
                                $scope.insuranceInCart = false;
                                break;

                            case 'voucher':
                                Voucher.resetItem();
                                break;

                            case 'bundle':
                            case 'event':
                                $scope.updateTicketInsurance();
                                $scope.updateTicketPersonalization();
                                break;

                            case 'product':
                                if (typeof CrossSell.products === 'object' && typeof CrossSell.products[ item.productcategoriesid ] === 'object'
                                    && CrossSell.products[ item.productcategoriesid ][ item.id ]
                                    && typeof CrossSell.products[ item.productcategoriesid ][ item.id ].detailData === 'object') {
                                    var ids = key.split('-');

                                    if (ids.length < 3) {
                                        CrossSell.products[ item.productcategoriesid ][ item.id ].detailData.amount = 0;
                                    } else {
                                        CrossSell.products[ item.productcategoriesid ][ item.id ].detailData.productsizes[ ids[ 2 ] ].amount = 0;
                                    }

                                    CrossSell.products[ item.productcategoriesid ][ item.id ].addAction = null;
                                }

                                removeProductFromLocalStorage(item);

                                if (typeof item.productid === 'string' && item.productid.indexOf('vt-') === 0 && !Voucher.isVoucherTypeInCart($scope)) {
                                    $scope.clearLocalStorage();
                                }

                                break;
                        }

                        if (item.type == 'event' || item.type == 'bundle') {
                            $scope.clearCartIfNoTickets();
                            $scope.checkIfTicketsInCart();
                        }
                        if (response.discount) {
                            Discount.setDiscount(response.discount, $scope);
                        }

                        $scope.checkBuyingVoucher();
                        $scope.setDefaultOptions(true);
                        $scope.updateCartSum();
                        $scope.checkAndRemoveEventAGB(item);
                        deferred.resolve(response);

                    } else {
                        exeStatus.items[ key ] = 0;
                        $scope.displayError(response.error);
                        deferred.reject(response.error);

                    }
                }, function (error) {
                    exeStatus.items[ key ] = 0;

                    $scope.displayError(error);
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        };

        /**
         * Remove those items from the localStorage
         */
        $scope.clearLocalStorage = function () {
            localStorage.removeItem('vouchertype-ticketformat');
            localStorage.removeItem('vouchertype-ticketformatid');
            localStorage.removeItem('currentTiemout');
            localStorage.removeItem('cart');
        };

        $scope.updateTicketInsurance = function () {
            if ($scope.insuranceOffer && $scope.cartItems[ 'insurance' ]) {
                $scope.cartItems[ 'insurance' ].price = $scope.insuranceOffer.price;
                if ($scope.insuranceOffer.length === 0) {
                    delete $scope.cartItems[ 'insurance' ];
                }
            } else {
                for (const index in $scope.cartItems) {
                    if ($scope.cartItems[ index ].type == 'insurance') {
                        delete $scope.cartItems[ index ];
                        break;
                    }
                }
            }
        };

        $scope.updateCartSum = function () {
            var sum = 0;
            var isEmptyCart = true;
            var buyingVoucherSum = 0;

            Cart.realSum = 0;
            $scope.cntSeats = 0;

            for (var i in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(i)) {
                    continue;
                }
                if (isEmptyCart) {
                    isEmptyCart = false;
                }

                var currentCartItem = $scope.cartItems[ i ];

                var price = 0;
                if (currentCartItem.type === 'bundle') {
                    var item, r;
                    for (r in currentCartItem.products) {
                        if (!currentCartItem.products.hasOwnProperty(r)) {
                            continue;
                        }
                        item = currentCartItem.products[ r ];

                        price = $scope.getDiscountPrice(item) ? item.discountprice : item.price;
                        sum += (price * item.amount);
                        Cart.realSum += (item.price * item.amount);
                    }
                    for (r in currentCartItem.seats) {
                        if (!currentCartItem.seats.hasOwnProperty(r)) {
                            continue;
                        }
                        item = currentCartItem.seats[ r ];
                        $scope.cntSeats++;

                        price = $scope.getDiscountPrice(item) ? item.discountprice : item.price;
                        sum += (price * item.amount);
                        Cart.realSum += (item.price * item.amount);
                    }
                } else {
                    price = $scope.getDiscountPrice(currentCartItem) ? currentCartItem.discountprice : currentCartItem.price;
                    sum += (price * currentCartItem.amount);
                    Cart.realSum += (currentCartItem.price * currentCartItem.amount);

                    if (currentCartItem.type === 'event') {
                        $scope.cntSeats++;
                    } else if (currentCartItem.type == "product" && (currentCartItem.id == 999999999 || currentCartItem.vouchertypeid)) {
                        buyingVoucherSum += price * 1;
                    }
                }
            }

            if (!isEmptyCart) {
                if (Cart.shippingMethod) {
                    var shippingPrice = ShippingMethodService.getPrice(Cart.shippingMethod, Cart);
                    sum += shippingPrice;
                    Cart.realSum += shippingPrice;
                }
                if ($scope.Cart.paymentMethod) {
                    sum += $scope.Cart.paymentMethod.costs * 1;
                    Cart.realSum += $scope.Cart.paymentMethod.costs * 1;
                }

                if ($scope.cntSeats <= 0) {
                    $scope.insuranceOffer = null;
                }
            } else {
                $scope.cartItems = null;
                $scope.insuranceOffer = null;

                $scope.unsetContents();
            }

            if (Voucher.item && sum - buyingVoucherSum <= 0) {
                var worth = (sum - buyingVoucherSum) * (-1);
                sum = buyingVoucherSum;

                Cart.realSum = buyingVoucherSum;
                Voucher.residualValue = worth;
            } else {
                Voucher.residualValue = 0;
            }

            if ((typeof Cart.ticketFormat === 'undefined' || (typeof Cart.ticketFormat !== 'undefined'
                && Cart.ticketFormat !== null && Object.keys(Cart.ticketFormat).length > 0 && Cart.ticketFormat.identifier !== 'printathome'))
                && (typeof Cart.paymentMethod !== 'undefined' && Cart.paymentMethod && Cart.paymentMethod.identifier === '-')) {
                Cart.paymentMethod = false;
            }

            if ((Cart.paymentVoucher === null || typeof Cart.paymentVoucher === 'undefined') && (sum <= 0 || (
                Cart.paymentMethod !== false && Cart.paymentMethod && parseInt(Cart.paymentMethod.costs) > 0 && (sum - parseInt(Cart.paymentMethod.costs)) <= 0
            )) && Cart.ticketFormat !== null && typeof Cart.ticketFormat !== 'undefined' && Object.keys(Cart.ticketFormat).length > 0 && Cart.ticketFormat.identifier === 'printathome') {
                //free of charge or voucher fake paymentMethod
                Cart.paymentMethod = { id: -1, identifier: '-', costs: 0 };
            }

            // we round for near 0 values
            Cart.realSum = Math.round(Cart.realSum * 1000) / 1000;
            sum = Math.round(sum * 1000) / 1000;
            $scope.cartSum = sum;
            Cart.sum = sum;
            $scope.checkCheckoutPossible();
        };

        $scope.checkInsuranceInCart = function () {
            $scope.insuranceInCart = false;
            for (var key in $scope.cartItems) {
                if (!$scope.cartItems.hasOwnProperty(key)) continue;
                var cartItem = $scope.cartItems[ key ];
                if (cartItem.type == "insurance") {
                    $scope.insuranceInCart = true;
                }
            }
        };

    };
    setExeStatus(exeStatus);
    return service;
};

export default CartHelper;
